<!-- Additional Options -->
<div class="additional-options">
  <p>
    Still facing issues?
    <a href="javascript:void(0)" class="option-link" (click)="logoutAndLogin()">
      Try logging in again
    </a>
  </p>
  <br />
  <p class="support-text">
    If you need assistance with this process, please reach out to our
    <a href="mailto:support@growth99.com" class="option-link">support team</a>.
  </p>
</div>
